import styled from 'styled-components';

export const StyledAppointmentForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 24px;
`;
StyledAppointmentForm.displayName = 'StyledAppointmentForm';

export const StyledWarnings = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;

   &:empty {
      display: none;
   }
`;
StyledWarnings.displayName = 'StyledWarnings';
